import React, {useContext} from 'react';

import {Nullable} from '@wix/premium-bricks-types';

import {Services} from './ServicesProvider';

export const ServicesContext = React.createContext<Services>(Nullable);
export const useServices = () => {
  return useContext(ServicesContext);
};
